/* eslint-disable react/no-array-index-key */
// @ts-nocheck
import Skeleton from '@mui/material/Skeleton';

import Table from '@experimental-components/Table';

import useStyles from './styles';

function SkeletonList() {
  const classes = useStyles();

  return (
    <>
      {[...Array(2)].map((row, i) => (
        <Table.Row className={classes.cell} key={`tr-${i}`}>
          {[...Array(2)].map((col, j) => (
            <Table.Cell isBorder={false} key={`tr-${i}-td-${j}`}>
              <Skeleton height={40} width="100%" />
            </Table.Cell>
          ))}
        </Table.Row>
      ))}
    </>
  );
}

export default SkeletonList;
